import { Routes } from '@angular/router';

import { AppRoutePath } from './app.routes.model';
import { authGuard, guestGuard } from '@staffler/core';

export const APP_ROUTES: Routes = [
  {
    path: AppRoutePath.ROOT,
    pathMatch: 'full',
    redirectTo: AppRoutePath.TABS,
  },
  {
    path: AppRoutePath.AUTH,
    loadChildren: () => import('./modules/auth/auth.routes').then(m => m.AUTH_ROUTES),
    canMatch: [guestGuard],
  },
  {
    path: AppRoutePath.ONBOARDING,
    loadChildren: () =>
      import('./modules/onboarding/onboarding.routes').then(m => m.ONBOARDING_ROUTES),
    canMatch: [authGuard],
  },
  {
    path: AppRoutePath.TABS,
    loadChildren: () => import('./modules/tabs/tabs.routes').then(m => m.TABS_ROUTES),
    canMatch: [authGuard],
  },
  {
    path: '**',
    redirectTo: AppRoutePath.AUTH,
  },
];
